let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e7Uqc")).then(() => parcelRequire('8khb6'));